<template>
  <div class="BreweryMap"/>
</template>

<script>
//import MarkerClusterer from '@google/markerclusterer';
import { EventBus } from '@/utils/event-bus.js';
import gmapsInit from '@/utils/gmaps';
import $ from 'jquery';
var infoWindow;

const markers = [];
const mapStyles = [
{
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#ebe3cd"
  }
  ]
},
{
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#523735"
  }
  ]
},
{
  "elementType": "labels.text.stroke",
  "stylers": [
  {
    "color": "#f5f1e6"
  }
  ]
},
{
  "featureType": "administrative",
  "elementType": "geometry.stroke",
  "stylers": [
  {
    "color": "#c9b2a6"
  }
  ]
},
{
  "featureType": "administrative.land_parcel",
  "elementType": "geometry.stroke",
  "stylers": [
  {
    "color": "#dcd2be"
  }
  ]
},
{
  "featureType": "administrative.land_parcel",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#ae9e90"
  }
  ]
},
{
  "featureType": "landscape.natural",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#dfd2ae"
  }
  ]
},
{
  "featureType": "poi",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#dfd2ae"
  }
  ]
},
{
  "featureType": "poi",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#93817c"
  }
  ]
},
{
  "featureType": "poi.park",
  "elementType": "geometry.fill",
  "stylers": [
  {
    "color": "#a5b076"
  }
  ]
},
{
  "featureType": "poi.park",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#447530"
  }
  ]
},
{
  "featureType": "road",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#f5f1e6"
  }
  ]
},
{
  "featureType": "road.arterial",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#fdfcf8"
  }
  ]
},
{
  "featureType": "road.highway",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#f8c967"
  }
  ]
},
{
  "featureType": "road.highway",
  "elementType": "geometry.stroke",
  "stylers": [
  {
    "color": "#e9bc62"
  }
  ]
},
{
  "featureType": "road.highway.controlled_access",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#e98d58"
  }
  ]
},
{
  "featureType": "road.highway.controlled_access",
  "elementType": "geometry.stroke",
  "stylers": [
  {
    "color": "#db8555"
  }
  ]
},
{
  "featureType": "road.local",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#806b63"
  }
  ]
},
{
  "featureType": "transit.line",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#dfd2ae"
  }
  ]
},
{
  "featureType": "transit.line",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#8f7d77"
  }
  ]
},
{
  "featureType": "transit.line",
  "elementType": "labels.text.stroke",
  "stylers": [
  {
    "color": "#ebe3cd"
  }
  ]
},
{
  "featureType": "transit.station",
  "elementType": "geometry",
  "stylers": [
  {
    "color": "#dfd2ae"
  }
  ]
},
{
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [
  {
    "color": "#b9d3c2"
  }
  ]
},
{
  "featureType": "water",
  "elementType": "labels.text.fill",
  "stylers": [
  {
    "color": "#92998d"
  }
  ]
}
];
const markersData = [
{
  Logo: "threeDaughters",
  lat: 27.769414,
  lng: -82.662735,
  name: "Three Daughters",
  UntappedId : 96120,
  Address : "222 22nd Street South",
  City : "St. Petersburg",
  Zip : 33712
},
{
  Logo: "7thsun",
  lat: 28.016453,
  lng: -82.790075,
  name: "7th Sun",
  UntappedId : 13146,
  Address : "1012 Broadway",
  City : "Dunedin",
  Zip : 34698
},
{
  Logo: "anecdote",
  lat: 27.88202773307938,
  lng: -82.85007693824232,
  name: "Anecdote Brewing Co",
  UntappedId : 465857,
  Address : "321 Gulf Blvd",
  City : "Indian Rocks Beach",
  Zip : 33785
},
{
  Logo: "arkaneAleworks",
  lat: 27.918507,
  lng: -82.760228,
  name: "Arkane Aleworks",
  UntappedId : 195431,
  Address : "2480 E Bay Dr. #23",
  City : "Largo",
  Zip : 33771
},

{
  Logo: "avidBrewing",
  lat: 27.770643,
  lng: -82.657302,
  name: "Avid Brewing",
  UntappedId : 283508,
  Address : "1745 1st Avenue S",
  City : "St. Petersburg",
  Zip : 33712
},

{
  Logo: "bigStorm",
  lat: 27.888210,
  lng: -82.699716,
  name: "Big Storm Brewing",
  UntappedId : 34308,
  Address : "12707 49TH Street",
  City : "Clearwater",
  Zip : 33762
},
{
  Logo: "cageBrewing",
  lat: 27.770700,
  lng: -82.660422,
  name: "Cage Brewing",
  UntappedId : 217901,
  Address : "2001 1st Ave South",
  City : "St. Petersburg",
  Zip : 33712
},
{
  Logo: "caledonia",
  lat: 28.013691,
  lng: -82.784337,
  name: "Caledonia Brewing",
  UntappedId : 32891,
  Address : "587 Main St",
  City : "Dunedin",
  Zip : 34698
},
{
  Logo: "cigar",
  lat: 27.959248836913087,
  lng: -82.50919391773215,
  name: "Cigar City Brewing",
  UntappedId : 379,
  Address : "3924 W. Spruce St",
  City : "Tampa",
  Zip : 33607
},
{
  Logo: "clearwater",
  lat: 27.982813,
  lng: -82.796777,
  name: "Clearwater Brewing",
  UntappedId : 426763,
  Address : "1700 N Fort Harrison Ave",
  City : "Clearwater",
  Zip : 33755
},
{
  Logo: "crooked",
  lat: 27.987741,
  lng: -82.698711,
  name: "Crooked Thumb Brewing",
  UntappedId : 225454,
  Address : "555 10th Ave S",
  City : "Safety Harbor",
  Zip : 34695
},
{
  Logo: "cueni",
  lat: 28.014885,
  lng: -82.788945,
  name: "Cueni Brewing Co",
  UntappedId : 308685,
  Address : "945 Huntley Ave",
  City : "Dunedin",
  Zip : 34698
},
{
  Logo: "cycleBrewing",
  lat: 27.771272,
  lng: -82.640940,
  name: "Cycle Brewing Co",
  UntappedId : 44115,
  Address : "534 Central Avenue",
  City : "St. Petersburg",
  Zip : 33701
},
{
  Logo: "dissentCraftBrewing",
  lat: 27.822545,
  lng: -82.670333,
  name: "Dissent Brewing Co",
  UntappedId : 310744,
  Address : "5518 Haines Rd",
  City : "St. Petersburg",
  Zip : 33714
},

{
  Logo: "dunedin",
  lat: 28.014274,
  lng: -82.787507,
  name: "Dunedin Brewery",
  UntappedId : 471,
  Address : "937 Douglas Ave",
  City : "Dunedin",
  Zip : 34698
},

{
  Logo: "flyingBoat",
  lat: 27.783004,
  lng: -82.657674,
  name: "Flying Boat Brewing",
  UntappedId : 295386,
  Address : "1776 11th Ave. N.",
  City : "St. Petersburg",
  Zip : 33713
},
{
  Logo: "greenBenchBrewing",
  lat: 27.771805,
  lng: -82.650636,
  name: "Green Bench",
  UntappedId : 60255,
  Address : "1133 Baum Ave North",
  City : "St. Petersburg",
  Zip : 33705
},
{
  Logo: "gulfport",
  lat: 27.740167,
  lng: -82.708260,
  name: "Gulfport Brewery",
  UntappedId : 447282,
  Address : "3007 Beach Blvd",
  City : "Gulfport",
  Zip : 33707
},
{
  Logo: "grindhaus",
  lat: 27.982191,
  lng: -82.756966,
  name: "Grindhaus Brew Lab",
  UntappedId : 245982,
  Address : "1650 N Hercules Ave",
  City : "Clearwater",
  Zip : 33765
},
{
  Logo: "hob",
  lat: 28.014023,
  lng: -82.789027,
  name: "HOB Brewing Company",
  UntappedId : 184244,
  Address : "Monroe St",
  City : "Dunedin",
  Zip : 34698
},
{
  Logo: "madBeach",
  lat: 27.786883,
  lng: -82.783397,
  name: "Mad Beach Brewing",
  UntappedId : 85158,
  Address : "12945 Village Blvd.",
  City : "Madeira Beach",
  Zip : 33708
},
{
  Logo: "mastrysBrewing",
  lat: 27.744800,
  lng: -82.751263,
  name: "Mastry's Brewing Co",
  UntappedId : 188433,
  Address : "7701 Blind Pass Road",
  City : "St. Pete Beach",
  Zip : 33706
},
{
  Logo: "overflow",
  lat: 27.772096,
  lng: -82.644535,
  name: "Overflow Brewing Co",
  UntappedId : 128427,
  Address : "770 1st Ave N",
  City : "St. Petersburg",
  Zip : 33708
},
{
  Logo: "pinellasAleWorks",
  lat: 27.770147,
  lng: -82.660045,
  name: "Pinellas Ale Works ",
  UntappedId : 127559,
  Address : "1962 1st Avenue S",
  City : "St. Petersburg",
  Zip : 33712
},
{
  Logo: "rapp",
  lat: 27.870951,
  lng: -82.735513,
  name: "Rapp Brewing Company",
  UntappedId : 20057,
  Address : "10930 Endeavour Way",
  City : "Seminole",
  Zip : 33777
},
{
  Logo: "soggy",
  lat: 28.015576,
  lng: -82.782811,
  name: "Soggy Bottom Brewery",
  UntappedId : 114422,
  Address : "660 Main St",
  City : "Dunedin",
  Zip : 34698
},
{
  Logo: "southernLights",
  lat: 27.960215,
  lng: -82.752445,
  name: "Southern Lights Brewing",
  UntappedId : 325031,
  Address : "2045 Gulf to Bay Blvd",
  City : "Clearwater",
  Zip : 33765
},
{
  Logo: "stPeteBrewing",
  lat: 27.772038,
  lng: -82.640999,
  name: "St Pete Brewing Co",
  UntappedId : 135387,
  Address : "544 1st Avenue North",
  City : "St. Petersburg",
  Zip : 33701
},
{
  Logo: "troubled",
  lat: 27.990725,
  lng: -82.694025,
  name: "Troubled Waters Brewing",
  UntappedId : 385993,
  Address : "670 Main St",
  City : "Safety Harbor",
  Zip : 34695
},
{
  Logo: "woodWrightBrewing",
  lat: 28.015726,
  lng: -82.787713,
  name: "Woodwright Brewing Co",
  UntappedId : 256978,
  Address : "985 Douglas Ave",
  City : "Dunedin",
  Zip : 34698
}

];
export default {
  name: `BreweryMap`,
  data() {
    return {
      markersData: [],
      markers: []
    }
  },
  created(){
    this.markersData = markersData;
    this.markers = markers;
    this.mapStyles = mapStyles;
    const vm = this;
    window.editVehicle = function(i) {
      vm.emitGlobalClickEvent(i);
    }
  },
  async mounted() {
    try {
      const google = await gmapsInit();
      const geocoder = new google.maps.Geocoder();
      const map = new google.maps.Map(this.$el);

      geocoder.geocode({ address: `Pinellas County, Florida` }, (results, status) => {
        if (status !== `OK` || !results[0]) {
          throw new Error(status);
        }
        map.setCenter(results[0].geometry.location);
        map.fitBounds(results[0].geometry.viewport);
        map.set('fullscreenControl', false);
        map.set('mapTypeControl', false);
        map.set('streetViewControl', false);
        map.set('styles', this.mapStyles);

      });


      for (var i = 0; i < this.markersData.length; i++){  
        var logo = this.markersData[i].Logo;     
        var name = this.markersData[i].name;
        var address = this.markersData[i].Address;
        var city = this.markersData[i].City;
        var zip = this.markersData[i].Zip;
        var untappedid = this.markersData[i].untappedid;
        var myLatLng = {lat: this.markersData[i].lat, lng: this.markersData[i].lng};
        var infowindow = new google.maps.InfoWindow();
        var bgImg = "/img/breweryCardBg/" + logo + "-cardBg.jpg";
   

        var icon = {
    url: "/img/pints/amber-brown-pint.svg", // url
    scaledSize: new google.maps.Size(40, 40), // scaled size
    origin: new google.maps.Point(0,0), // origin
    anchor: new google.maps.Point(0, 0) // anchor
  };
  

  var marker = new google.maps.Marker({
    logo: logo,
    bgImg: bgImg,
    position: myLatLng,
    map: map,
    animation: google.maps.Animation.DROP,
    address: address,
    city: city,
    zip: zip,
    name: name,
    icon: icon,
    untappedid: untappedid
  });

  google.maps.event.addListener(marker, 'click', (function(marker, i) {
    return function() {
      var markerNumber = i;
      var iwContent = 
      '<div class="map-logo-cont" style="background-size: cover; background-image:url(' + this.bgImg + ')">' +
      '<img src="/img/breweryLogos/' + this.logo + '-logo.png" /></div><div class="map-addy">' + 
      '<h3>' + this.name + '</h3>' +
      '<p>' + this.address + '<br />' +
      this.city + '<br />' +
      this.zip + '</p>' +
      '<button class="map-info-button" onclick="editVehicle(' + markerNumber + ');">VIEW DETAILS</button></div>'
      ;

      infowindow.setContent(iwContent);
      document.getElementById('map-info').innerHTML = iwContent;
            //infowindow.open(map, marker);
          }
        })(marker, i));

           /* google.maps.event.addListener(marker, 'mouseout', (function(marker, i) {
              return function() {
                infowindow.close(map, marker);
              }
            })(marker, i));*/

          }

        } catch (error) {
          console.error(error);
        }
      },
      methods: {
        emitGlobalClickEvent(number){
          var number = number;
          var chosenBar = this.markersData[number].UntappedId;
          //alert(chosenBar);
          EventBus.$emit('map-marker-click', chosenBar);
        }
      }


    };
    </script>

    <style>

    .BreweryMap{
      overflow:hidden;
      padding-bottom:90.25%;
      margin-left:-15px;
      margin-right:-15px;
      margin-top:0px;
      position:relative;
      height:0;
    }

    .BreweryMap iframe{
      left:0;
      top:0;
      height:100%;
      width:100%;
      position:absolute;
    }

    @media(min-width:768px){
      .BreweryMap {
        
        padding-bottom:56.25%;
      }
    }

    .gm-style .gm-style-iw-c {
      position: absolute;
      box-sizing: border-box;
      overflow: hidden;
      top: 0;
      left: 0;
      transform: translate(-50%,-100%);
      background-color: white;
      border-radius: 3px;
      padding: 20px;
      box-shadow: 0 2px 7px 1px rgba(0,0,0,0.3);
    }
    .map-info-button{
      background-color: #903030;
      border: 0px solid #fff;
      border-top: 1px solid #903030;
      border-right: 1px solid #903030;
      border-bottom: 1px solid #903030;
      color: #ffffff;
      display: block;
      font-size: 14px;
      line-height: 18px;
      margin: 20px auto 0 auto;
      border-radius: 5px;
      padding: 8px 20px 8px 20px;
      width:100%;
    }

    .gm-style .gm-style-iw-t::after {
      border-left: 1px solid #903030;
      border-bottom: 1px solid #903030;
      top: -1px;
    }
    </style>